<template>
    <div
        id="tooltip"
        role="tooltip"
        class="rounded-2xl bg-white px-4 py-2 block drop-shadow-md"
    >
        <div id="arrow" data-popper-arrow></div>
        <slot />
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "TooltipWrapper",
});
</script>
